// Admin Color Constants
// Centralized color management for admin interface components

export const ADMIN_COLORS = {
  // Background Colors
  BACKGROUND: {
    PRIMARY: '#242424',           // Main admin background
    SECONDARY: '#171717',         // Secondary admin background
    MODAL_OVERLAY: 'transparent', // Modal overlay background
    INPUT: '#464646', // Input background
  },

  INPUT: {
    PRIMARY: '#464646',
    SECONDARY: '#242424',
    BORDER: '#757575',
  },
  
  // Surface color for cards, panels
  SURFACE: '#242424',

  // Border Colors
  BORDER: '#2F2F2F',
  BORDER_SECONDARY: '#464646',

  // Text Colors
  TEXT: {
    PRIMARY: '#EEF1F4',      // Primary text color (white-ish)
    SECONDARY: '#acacac',
    ACCENT: '#6B8EFE',       // Accent text color (blue)
    ERROR: '#FF6B6B',        // Error text color
  },

  // Additional Text Colors for Error Handling
  TEXT_PRIMARY: '#EEF1F4',
  TEXT_SECONDARY: '#919191',
  TEXT_TERTIARY: '#757575',
  TEXT_BLACK: "#171717",
  CHAT_FOOTER_TEXT:'#CFCFCF',
  
  // Status Colors
  PRIMARY: '#6B8EFE',
  ERROR: '#FF6B6B',
  SUCCESS: '#4CAF50',
  WARNING: '#FF9800',
  INFO: '#2196F3',
  
  // Transaction-specific colors
  TRANSACTION: {
    PAYMENT: '#10B981',       // Green for payments
    CHARGE: '#EF4444',        // Red for charges/debits
    PENDING: '#F59E0B',       // Orange for pending states
    VOIDED: '#6B7280',        // Gray for cancelled/inactive
  },

  // Interactive Elements
  INTERACTIVE: {
    PRIMARY: '#6B8EFE',      // Primary interactive color (buttons, links)
  },

  // Component Specific Colors
  SELECTOR: {
    BACKGROUND: '#242424',
    BORDER: '#ACACAC',
    TEXT: '#EEF1F4',
    TEXT_DISABLED: '#919191',
    LABEL: '#919191',
    DROPDOWN_BACKGROUND: '#242424',
    DROPDOWN_BORDER: '#ACACAC',
    ITEM_SELECTED_BACKGROUND: '#171717',
    ITEM_SELECTED_TEXT: '#6B8EFE',
    SELECTED_INDICATOR: '#6B8EFE',
  },

  HEADER: {
    BACKGROUND: '#242424',
    MENU_TEXT: '#EEF1F4',
  },

  NAVIGATION: {
    BACKGROUND: '#242424',
    BORDER: '#2F2F2F',
    ITEM_BORDER: '#2F2F2F',
    ITEM_BACKGROUND_OPEN: '#171717',
    ITEM_BORDER_ACTIVE: '#6B8EFE',
    TITLE: '#EEF1F4',
    DESCRIPTION: '#919191',
    CHILD_TEXT: '#919191',
    CHILD_TEXT_SELECTED: '#EEF1F4',
    SELECTED_INDICATOR: '#6B8EFE',
  },

  BUTTON: {
    PRIMARY_BACKGROUND: '#EEF1F4',
    PRIMARY_TEXT: '#171717',
    ADD_BUTTON_BACKGROUND: '#F55560',
  },

  // Bulletins specific colors
  BULLETINS: {
    FRAME_BACKGROUND: '#171717',
    TITLE_TEXT: '#EEF1F4',
    EMPTY_STATE_TITLE: '#EEF1F4',
    EMPTY_STATE_SUBTITLE: '#919191',
    GRADIENT_BLUE: '#4773FE',
    GRADIENT_PURPLE: '#BE5EC8',
    GRADIENT_RED: '#F55560',
  },

  // DATA TABLE
  DATA_TABLE: {
    BACKGROUND: '#171717',
    HEADER_BACKGROUND: '#000000',
    BORDER: '#242424',
    FILTER_BACKGROUND: '#242424',
    TEXT: '#EEF1F4',
    PAGINATION_TEXT: '#757575',
    PAGINATION_BUTTON_DISABLED: '#757575',
    PAGINATION_BUTTON_ENABLED: '#FFFFFF',
  },

  // Shadow Colors
  SHADOW: {
    DEFAULT: '#000',         // Default shadow color
  },
} as const;

// Commonly used color combinations
export const ADMIN_COLOR_COMBINATIONS = {
  // Input field styling
  INPUT_DEFAULT: {
    backgroundColor: ADMIN_COLORS.SELECTOR.BACKGROUND,
    borderColor: ADMIN_COLORS.SELECTOR.BORDER,
    color: ADMIN_COLORS.SELECTOR.TEXT,
  },

  // Button styling
  BUTTON_PRIMARY: {
    backgroundColor: ADMIN_COLORS.BUTTON.PRIMARY_BACKGROUND,
    color: ADMIN_COLORS.BUTTON.PRIMARY_TEXT,
  },

  // Navigation item styling
  NAV_ITEM_DEFAULT: {
    backgroundColor: 'transparent',
    borderColor: ADMIN_COLORS.NAVIGATION.ITEM_BORDER,
    color: ADMIN_COLORS.NAVIGATION.TITLE,
  },

  NAV_ITEM_ACTIVE: {
    backgroundColor: ADMIN_COLORS.NAVIGATION.ITEM_BACKGROUND_OPEN,
    borderColor: ADMIN_COLORS.NAVIGATION.ITEM_BORDER_ACTIVE,
    color: ADMIN_COLORS.NAVIGATION.TITLE,
  },
} as const;
